const list = [
    { id: "16093.4", name: "10 miles" },
    { id: "32186.9", name: "20 miles" },
    { id: "48280.3", name: "30 miles" },
    { id: "64373.8", name: "40 miles" },
    { id: "80467.2", name: "50 miles" },
    { id: "96560.6", name: "60 miles" },
    { id: "112654", name: "70 miles" },
    { id: "128748", name: "80 miles" },
    { id: "144841", name: "90 miles" },
    { id: "160934", name: "100 miles" },
]

const find = (key) => {
    let ext = list.find((itm) => itm.id == key);
    return ext;
};

const name = (key) => {
    let ext = list.find((itm) => itm.id == key);
    return ext ? ext.name : key;
};

const milesModal = { list, find, name };
export default milesModal;
